export default __webpack_public_path__ + "buysearchsell/images/apple-touch-icon.png";